<template>
    <div>    
        <el-table
        :data="painspot_info"
        :empty-text="emptyText"
        stripe
        border
        style="width: 100%">
            <el-table-column
                prop="pain_spot_num"
                label="序号"
                min-width="5%">
            </el-table-column>
            <el-table-column
                prop="pain_spot"
                label="痛点"
                min-width="35%">
            </el-table-column>
            <el-table-column
                prop="pain_spot_analysis"
                label="原因分析"
                min-width="60%">
                <template slot-scope="scope">
                    <p v-for="(item, i) in scope.row.pain_spot_analysis" :key="i">{{ item }}</p>
                </template>
            </el-table-column>
        </el-table>
    </div>   
</template>

<script>
import postdata from "@/api/postData.js";
// import getdata from "@/api/getData.js";
export default {
    // 组件传递的prop数据，会在beforeUpdate钩子期间生效！
    // beforeUpdate() {
    //     if(this.question_info.length <= 0){
    //         this.display_flag = true;
    //     }else{
    //         // 这里要增加else的处理，在导入模板后更新display_flag的值，因为没有重新加载页面，所以此时的display_flag不会从重置为初始值false开始判断
    //         this.display_flag = false;
    //     }
    // },
    data() {
        return {
            template_file: {
                file_name: 'health-survey-pain-spot-import_template.xlsx'
            },
            formInline: {
                search_info: '',
                search_result: [],
            },
            display_flag: false,
            emptyText: '暂无管理痛点调研问卷信息，请先导入。',
        }
    },
    props: ['painspot_info', 'error_flag'],
    methods: {
        Download_template() {
            postdata.downloadFiles("download", JSON.stringify(this.template_file))
              .then(resp => {
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                this.download(resp);
              })
              .catch(err => {
                console.log(err);
              })
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
        // 向父组件传递问卷测评结果（包括选择题和举证题两部分）
        submitManaQues() {
            // console.log('send data to father component.');
            this.$emit('sendData', this.painspot_info);
        },
    }
}
</script>

<style scoped>
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
</style>